import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { ErrorHandlingService } from "src/app/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from 'src/app/features/security-zone/secure-zone-api-endpoints';
import { catchError, map } from "rxjs/operators";

interface GetPlatformsResponse {
  platforms: Platform[];
}

interface GetPlatformResponse {
  platform: Platform;
}

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
      private readonly apiUrl = environment.apiUrl;
      constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }
    
      getPlatforms(currentPage: number): Observable<Platform[]> {
        return this.http.post<GetPlatformsResponse>(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.FETCH}`, { currentPage })
          .pipe(
              map(response => response.platforms),
                    catchError(error => this.errorHandlingService.handleError(error))
                  );
      }
      
    
      getPlatform(platformId: string): Observable<Platform> {
        return this.http.post<GetPlatformResponse>(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.GET}`,{platformId})
          .pipe(
            map(response => response.platform),
            catchError(error => this.errorHandlingService.handleError(error))
          );
      }
    
    
      getPlatformsSearch(currentPage: number, searchText: String, filterByHeader: String): Observable<Platform[]> {
        return this.http.post<GetPlatformsResponse>(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.SEARCH}`, { currentPage, searchText, filterByHeader })
          .pipe(
            map(response => response.platforms),
            catchError(error => this.errorHandlingService.handleError(error))
          );
      }
    
      createPlatform(platformName: string, description: string, category: string): Observable<GetPlatformResponse> {
        return this.http.post<GetPlatformResponse>(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.CREATE}`, { platformName, description, category })
          .pipe(
            map(response => response),
            catchError(error => this.errorHandlingService.handleError(error))
          );
      }
    
      updatePlatform(platformId: string, platformName: string, description: string, category: string): Observable<any> {
        return this.http.post(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.UPDATE}`, { platformId, platformName, description, category })
          .pipe(
            map(response => response),
            catchError(error => this.errorHandlingService.handleError(error))
           ); 
      }
    
      deletePlatform(platformId: string): Observable<any> {
        return this.http.post(`${this.apiUrl}${API_ENDPOINTS.PLATFORM.DELETE}`, { platformId })
          .pipe(
            catchError(error => this.errorHandlingService.handleError(error))
           ); 
      }
}